import React from "react";
import MainButton from "../MainButton/MainButton";
import TextFiled from "../InputField/TextFiled";
import TextArea from "../InputField/TextArea";
import { useState } from "react";
import Heading from "../Typography/Heading";
import Paragraph from "../Typography/Paragraph";
import AuxiliaryText from "../Typography/AuxiliaryText";
import FieldDropdown from "../InputField/FieldDropdown";
import SpecialText from "../Typography/SpecialText";
import { runTextPipeline, validateFile, getAcceptAttribute } from "../../../utils/contentSafety";
import Alerts from "../Alerts/Alerts";
import { FIELD_UPLOAD_FULL } from "../InputField/fieldSystem";
import { POPUP_FORM_CONTENT_WIDTH_CLASS } from "../../popup/popupLayoutSpec";

const ReviewReport = ({ closePopup }) => {
  const [step, setStep] = useState(1);
  const [selectedReason, setSelectedReason] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [reportFiles, setReportFiles] = useState([]);
  const reasons = [
    { name: "Incorrect business details" },
    { name: "Unprofessional conduct" },
    { name: "Unauthorized use of images" },
    { name: "Misleading business information" },
    { name: "Violation of platform policies" },
    { name: "Other (please specify)" },
  ];

  //   const filesData = [...files];
  //   setImageList((state) => {
  //     return [
  //       ...state,
  //       ...filesData.map((file) => ({
  //         file: file,
  //         url: URL.createObjectURL(file),
  //       })),
  //     ];
  //   });
  // };
  const completion = 76;
  return (
    <>
      <>
        {step === 1 && (
          <>
            <div className="bg-pastalblue">
              <Heading
                variant={"h6"}
                className={
                  "flex items-center justify-center text-offblack mt-10 lg:mt-20 xl:mt-28"
                }
              >
                Report this review
              </Heading>
              <div className="h-[700px] overflow-auto pt-10 pb-60 hidden-scrollbar">
                <div className={`${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto`}>
                  <div>
                    <div>
                      <TextFiled
                        variant={"large"}
                        fullWidth
                        label={"Name"}
                        placeholder={"Please enter your full name"}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className={"mt-5"}>
                      <TextFiled
                        variant={"large"}
                        fullWidth
                        label={"Contact Information"}
                        placeholder={"Provide your email or phone number"}
                      />
                    </div>
                    <div className="mt-5">
                      <FieldDropdown
                        label="Nature of Complaint"
                        variant="general"
                        fullWidth
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.value)}
                        options={reasons}
                        optionLabel="name"
                        placeholder="Select the issue"
                      />
                    </div>
                    <div className="mt-5">
                      <TextArea
                        variant={"large"}
                        fullWidth
                        label={"Detailed Description"}
                        placeholder={"Describe the issue in detail"}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div>
                      <div className="mt-5">
                        <label className={`block mb-2`}>
                          <AuxiliaryText variant={"FieldLabel"}>
                            Upload Evidence
                          </AuxiliaryText>
                        </label>
                        <div className="w-full min-w-0">
                          <input
                            type="file"
                            id="review-report-files"
                            accept={getAcceptAttribute("image")}
                            className="hidden"
                            multiple
                            onChange={(e) => {
                              const files = e.target.files ? Array.from(e.target.files) : [];
                              for (const file of files) {
                                const result = validateFile(file, "image");
                                if (!result.valid) {
                                  Alerts.error(result.message);
                                  e.target.value = "";
                                  return;
                                }
                              }
                              setReportFiles(files);
                              e.target.value = "";
                            }}
                          />
                          <label
                            role="button"
                            htmlFor="review-report-files"
                            className={`${FIELD_UPLOAD_FULL} flex cursor-pointer items-center justify-center`}
                          >
                            <div className="my-auto">
                              <div className="flex justify-center">
                                <div className="flex justify-center items-center">
                                  <i className="fi fi-rs-inbox-out text-base text-offblack"></i>
                                </div>
                              </div>
                              <div className="flex justify-center">
                                <AuxiliaryText
                                  variant={"Placeholder"}
                                  className={"mt-1 text-primaryblue"}
                                >
                                  Upload Files
                                </AuxiliaryText>
                              </div>
                            </div>
                          </label>
                        </div>
                        {/* <div className="mt-10 w-full">
                          <div className="flex gap-3 w-full">
                            <i className="fi fi-br-picture text-[50px] text-primaryblue"></i>
                            <div className="w-full flex flex-col gap-2 mt-5">
                              <div className="flex items-center justify-between w-full">
                                <AuxiliaryText variant={"FieldLabel"}>
                                  myprofile.png
                                </AuxiliaryText>

                                <AuxiliaryText variant={"FieldLabel"}>
                                  {completion}%
                                </AuxiliaryText>
                              </div>
                              <div className="w-full h-1.5 bg-white rounded-full">
                                <div
                                  className={`h-full bg-primaryblue rounded-full`}
                                  style={{ width: `${completion}%` }}
                                ></div>
                              </div>
                            </div>
                            <i className="fi fi-rs-cross text-sm cursor-pointer mt-10"></i>
                          </div>
                          <div className="flex gap-3 w-full mt-5">
                            <i className="fi fi-br-picture text-[50px] text-primaryblue"></i>
                            <div className="w-full flex flex-col gap-2 mt-5">
                              <div className="flex items-center justify-between w-full">
                                <AuxiliaryText variant={"FieldLabel"}>
                                  myprofile.png
                                </AuxiliaryText>

                                <AuxiliaryText variant={"FieldLabel"}>
                                  {completion}%
                                </AuxiliaryText>
                              </div>
                              <div className="w-full h-1.5 bg-white rounded-full">
                                <div
                                  className={`h-full bg-primaryblue rounded-full`}
                                  style={{ width: `${completion}%` }}
                                ></div>
                              </div>
                            </div>
                            <i className="fi fi-rs-cross text-sm cursor-pointer mt-10"></i>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className={`${POPUP_FORM_CONTENT_WIDTH_CLASS} mt-10`}>
                      <div className="flex justify-start mt-5">
                        <SpecialText variant={"FootNoteDisclaimer"}>
                          Privacy & Agreement
                        </SpecialText>
                      </div>
                      <SpecialText
                        variant={"FootNoteDisclaimer"}
                        className={"mt-3"}
                      >
                        By submitting this complaint, you agree that Trades
                        Poster may use your information to review and address
                        the issue. We may contact you for further details if
                        necessary.
                      </SpecialText>
                    </div>
                    <div className="flex items-center mt-10">
                      <label
                        className="relative flex items-center rounded-full cursor-pointer mr-3"
                        htmlFor="link"
                      >
                        <input
                          type="checkbox"
                          className="before:content[''] peer relative size-4 cursor-pointer appearance-none rounded-[4px] border border-mediumgray transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primaryblue checked:bg-primaryblue checked:before:bg-primaryblue"
                          id="link"
                        />
                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-[40%] left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                          <i className="fi fi-rs-check text-[10px]"></i>
                        </span>
                      </label>
                      <SpecialText
                        variant={"FootNoteDisclaimer"}
                        className={"text-offblack"}
                      >
                        I confirm the information provided is accurate.
                      </SpecialText>
                    </div>
                    <div>
                      <div className="flex items-center justify-end mt-10">
                        <MainButton
                          variant={"small"}
                          onClick={() => {
                            if (name.trim()) {
                              const nameResult = runTextPipeline(name.trim(), "name");
                              if (!nameResult.valid) {
                                Alerts.error(nameResult.message);
                                return;
                              }
                            }
                            if (description.trim()) {
                              const descResult = runTextPipeline(description.trim(), "report");
                              if (!descResult.valid) {
                                Alerts.error(descResult.message);
                                return;
                              }
                            }
                            setStep(2);
                            setTimeout(closePopup, 3000);
                          }}
                        >
                          Submit
                        </MainButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div className="bg-pastalblue">
              <Heading
                variant={"h6"}
                className={
                  "flex items-center justify-center text-offblack mt-10 md:mt-28"
                }
              >
                Complaint Submitted
              </Heading>
              <div className={`flex ${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto rounded-lg`}>
                <div className="w-full">
                  <div>
                    <div className="w-full">
                      <Paragraph variant={"MainParagraph"} className={"mt-10"}>
                        Thank you for reporting this business. Our team will
                        thoroughly review your complaint and take the necessary
                        actions. If we need further details, we will contact
                        you. Please keep an eye on your email for updates as we
                        investigate your report.
                      </Paragraph>
                    </div>
                  </div>
                  <div className="flex justify-center my-10">
                    <i className="fi fi-ss-badge-check text-[4.5rem] text-primaryblue size-[4.5rem]"></i>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default ReviewReport;
